/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} IntegrationsInputs */

const en_integrations = /** @type {(inputs: IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrations`)
};

const fr_integrations = /** @type {(inputs: IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégrations`)
};

const de_integrations = /** @type {(inputs: IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrationen`)
};

const it_integrations = /** @type {(inputs: IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrazioni`)
};

const ru_integrations = /** @type {(inputs: IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Интеграции`)
};

const es_integrations = /** @type {(inputs: IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integraciones`)
};

const zh_cn2_integrations = /** @type {(inputs: IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集成`)
};

const ja_integrations = /** @type {(inputs: IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`統合`)
};

const hi_integrations = /** @type {(inputs: IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एकीकरण`)
};

const pt_pt2_integrations = /** @type {(inputs: IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrações`)
};

/**
* | output |
* | --- |
* | "Integrations" |
*
* @param {IntegrationsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const integrations = /** @type {((inputs?: IntegrationsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<IntegrationsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_integrations(inputs)
	if (locale === "de") return de_integrations(inputs)
	if (locale === "it") return it_integrations(inputs)
	if (locale === "ru") return ru_integrations(inputs)
	if (locale === "es") return es_integrations(inputs)
	if (locale === "zh-CN") return zh_cn2_integrations(inputs)
	if (locale === "ja") return ja_integrations(inputs)
	if (locale === "hi") return hi_integrations(inputs)
	if (locale === "pt-PT") return pt_pt2_integrations(inputs)
	return en_integrations(inputs)
});